import { GpfHistoryTable } from "./components";

export interface GpfPropsType {
  id: number | null;
  isEditEmployee: boolean;
}

function GpfHistory({ id, isEditEmployee }: GpfPropsType) {
  return (
    <div className="pt-10">
      <GpfHistoryTable id={id as number} isEditEmployee={isEditEmployee} />
    </div>
  );
}
export default GpfHistory;
